import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { TPublicationsReportReportingPeriodPresentationModel } from "../../../../presenter/report/model/PublicationsReportReportingPeriodPresentationModel";
import { Typography, Row, Col } from "antd";
import PublicationsReportReportsGrid from "./PublicationsReportReportsGrid";

const PublicationsReportReportingPeriod = ({
  translate,
  reportingPeriod
}: {
  translate: TTranslate;
  reportingPeriod: TPublicationsReportReportingPeriodPresentationModel;
}) => {
  return (
    <div>
      <Typography.Title style={{ fontSize: 15, marginBottom: 10 }}>
        {`${translate("publications_report.reporting_period.name")}: ${
          reportingPeriod.reportingPeriodName
        }`}
      </Typography.Title>

      <Row>
        <Col span={6}>
          <Typography.Paragraph>
            {`${translate(
              "publications_report.reporting_period.additional_evaluation"
            )}: ${
              reportingPeriod.additionalEvaluationIndicator
                ? translate("basic.yes")
                : translate("basic.no")
            }`}
          </Typography.Paragraph>
        </Col>
        <Col span={6}>
          <Typography.Paragraph>
            {`${translate(
              "publications_report.reporting_period.additional_evaluation_status"
            )}: ${reportingPeriod.additionalEvaluationStatus}`}
          </Typography.Paragraph>
        </Col>
        <Col span={6}>
          <Typography.Paragraph>
            {`${translate(
              "publications_report.reporting_period.additional_evaluation_date"
            )}: ${reportingPeriod.additionalEvaluationDate}`}
          </Typography.Paragraph>
        </Col>
      </Row>
      <PublicationsReportReportsGrid
        translate={translate}
        reports={reportingPeriod.reports}
      />
    </div>
  );
};

export default PublicationsReportReportingPeriod;
